import { useState } from "react";
import { FeaturedCitiesPicker } from "./FeaturedCitiesPicker";

const COUNTRIES = ["UK", "US", "IE", "DE", "FR", "IT", "ES", "PT"];

export function FeaturedFirmsPicker() {
  const [cc, setCc] = useState("UK");
  return (
    <div className="space-y-3" data-testid="featured-firms-admin">
      <div className="flex flex-wrap gap-1.5" role="tablist" aria-label="Country roster">
        {COUNTRIES.map((c) => (
          <button key={c} type="button" role="tab" aria-selected={c === cc} onClick={() => setCc(c)}
            className={`px-3 py-1 rounded-full border text-sm transition-colors ${c === cc ? "bg-stone-900 text-white border-stone-900" : "bg-white border-stone-300 hover:border-stone-900"}`}
            data-testid={`featured-firms-admin-country-${c.toLowerCase()}`}>{c}</button>
        ))}
      </div>
      <FeaturedCitiesPicker key={cc} endpoint={`/admin/featured-firms?country=${cc}`} heading={`Homepage featured firms · ${cc}`}
        placeholder="Add a firm: type a name…" tid="featured-firms-picker" />
    </div>
  );
}
